
/*
===============================================================================
biehistoricalworkbook.normalizers.ts — additions
===============================================================================
*/

import { BieHistoricalWorkbookUploadResult, BieHistoricalWorkbookValidateResult } from "./biehistoricalworkbook.models";

function asString(value: any, fallback = ''): string {
  return value === undefined || value === null ? fallback : String(value);
}

function asNullableString(value: any): string | null {
  return value === undefined || value === null || value === ''
    ? null
    : String(value);
}

function asNumber(value: any, fallback = 0): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function asBoolean(value: any): boolean {
  return value === true || value === 1 || value === '1' || value === 'true';
}

function asArray(value: any): any[] {
  return Array.isArray(value) ? value : [];
}

export function normalizeBieHistoricalWorkbookUpload(
  source: any
): BieHistoricalWorkbookUploadResult {
  return {
    planningcycleid: asNumber(
      source?.planningCycleId ?? source?.planningcycleid
    ),

    historicaldatasetid: asNumber(
      source?.historicalDatasetId ?? source?.hdi
    ),

    historicaldatasetix: asString(source?.historicalDatasetIx),
    historicaldatasetcode: asString(source?.historicalDatasetCode),
    historicaldatasetname: asString(source?.historicalDatasetName),

    filename: asString(source?.filename),
    workbookVersion: asString(source?.workbookVersion),
    checksum: asString(source?.checksum),

    importCount: asNumber(source?.importCount),
    recordCount: asNumber(source?.recordCount),

    minimumPeriodDate: asNullableString(source?.minimumPeriodDate),
    maximumPeriodDate: asNullableString(source?.maximumPeriodDate),

    validationStatus: asString(source?.validationStatus, 'PENDING'),

    imports: asArray(source?.imports).map((item) => ({
      rid: asNumber(item?.rid),
      rix: asString(item?.rix),
      classId: asNumber(item?.classId),
      classCode: asString(item?.classCode),
      sheetName: asString(item?.sheetName),
      recordCount: asNumber(item?.recordCount),
    })),

    calendar: {
      startdate: asNullableString(source?.calendar?.startdate),
      enddate: asNullableString(source?.calendar?.enddate),
      inserted:
        source?.calendar?.inserted &&
          typeof source.calendar.inserted === 'object'
          ? source.calendar.inserted
          : {},
    },

    raw: source,
  };
}

export function normalizeBieHistoricalWorkbookValidate(
  source: any
): BieHistoricalWorkbookValidateResult {
  return {
    planningcycleid: asNumber(
      source?.planningCycleId ?? source?.planningcycleid
    ),

    historicaldatasetid: asNumber(
      source?.historicalDatasetId ?? source?.hdi
    ),

    checksum: asString(
      source?.workbookChecksum ?? source?.checksum
    ),

    importCount: asNumber(source?.importCount),
    recordCount: asNumber(source?.recordCount),

    validRows: asNumber(source?.validRows),
    warningRows: asNumber(source?.warningRows),
    failedRows: asNumber(source?.failedRows),

    blockingIssues: asNumber(source?.blockingIssues),
    committedRows: asNumber(source?.committedRows),

    validationStatus: asString(source?.validationStatus),
    usable: asBoolean(source?.usable),

    resolution:
      source?.resolution && typeof source.resolution === 'object'
        ? source.resolution
        : {},

    validation:
      source?.validation && typeof source.validation === 'object'
        ? source.validation
        : {},

    commit:
      source?.commit && typeof source.commit === 'object'
        ? source.commit
        : {},

    raw: source,
  };
}






// /*
// ===============================================================================
// biehistoricalworkbook.normalizers.ts
// ===============================================================================
// */

// import {
//   BieHistoricalWorkbookOperationResult,
//   BieHistoricalWorkbookReview,
//   BieHistoricalWorkbookReviewImport,
// } from './biehistoricalworkbook.models';

// function asString(value: any, fallback = ''): string {
//   return value === undefined || value === null ? fallback : String(value);
// }

// function asNullableString(value: any): string | null {
//   return value === undefined || value === null || value === ''
//     ? null
//     : String(value);
// }

// function asNumber(value: any, fallback = 0): number {
//   const parsed = Number(value);

//   return Number.isFinite(parsed) ? parsed : fallback;
// }

// function asNullableNumber(value: any): number | null {
//   if (value === undefined || value === null || value === '') {
//     return null;
//   }

//   const parsed = Number(value);

//   return Number.isFinite(parsed) ? parsed : null;
// }

// function asBoolean(value: any): boolean {
//   return value === true || value === 1 || value === '1' || value === 'true';
// }

// function asArray(value: any): any[] {
//   return Array.isArray(value) ? value : [];
// }

// function asStringArray(value: any): string[] {
//   return asArray(value).map((item) => String(item));
// }

// function normalizeImport(source: any): BieHistoricalWorkbookReviewImport {
//   return {
//     rid: asNumber(source?.rid),

//     rix: asString(source?.rix),

//     trackId: asString(source?.trackId),

//     planningcycleid: asNumber(source?.planningcycleid),

//     sourceId: asNullableNumber(source?.sourceId),

//     sourceCode: asString(source?.sourceCode),

//     sourceName: asString(source?.sourceName),

//     classId: asNullableNumber(source?.classId),

//     classCode: asString(source?.classCode),

//     className: asString(source?.className),

//     stateId: asNullableNumber(source?.stateId),

//     stateCode: asString(source?.stateCode),

//     stateName: asString(source?.stateName),

//     name: asString(source?.name),

//     code: asString(source?.code),

//     description: asNullableString(source?.description),

//     filename: asString(source?.filename),

//     sheetName: asString(source?.sheetName),

//     workbookVersion: asString(source?.workbookVersion),

//     checksum: asString(source?.checksum),

//     totalRows: asNumber(source?.totalRows),

//     stagedRows: asNumber(source?.stagedRows),

//     pendingRows: asNumber(source?.pendingRows),

//     validRows: asNumber(source?.validRows),

//     warningRows: asNumber(source?.warningRows),

//     failedRows: asNumber(source?.failedRows),

//     rejectedRows: asNumber(source?.rejectedRows),

//     committedRows: asNumber(source?.committedRows),

//     statusCode: asString(source?.statusCode),

//     message: asString(source?.message),

//     uploaderId: asNullableNumber(source?.uploaderId),

//     uploaderIx: asNullableString(source?.uploaderIx),

//     uploaderCode: asString(source?.uploaderCode),

//     uploaderName: asString(source?.uploaderName),

//     uploaderEmail: asString(source?.uploaderEmail),

//     uploadedAt: asNullableString(source?.uploadedAt),

//     created: asNullableString(source?.created),

//     extraInfo:
//       source?.extraInfo && typeof source.extraInfo === 'object'
//         ? source.extraInfo
//         : {},

//     status: asNumber(source?.status, 1),

//     stamp: asString(source?.stamp),

//     raw: source,
//   };
// }

// export function normalizeBieHistoricalWorkbookReview(
//   source: any
// ): BieHistoricalWorkbookReview {
//   const summary = source?.summary || {};

//   const actions = source?.actions || {};

//   return {
//     planningcycleid: asNumber(source?.planningcycleid),

//     planningcycleix: asString(source?.planningcycleix),

//     planningcyclecode: asString(source?.planningcyclecode),

//     planningcyclename: asString(source?.planningcyclename),

//     scopeId: asNumber(source?.scopeId),

//     scopeCode: asString(source?.scopeCode),

//     scopeName: asString(source?.scopeName),

//     stateId: asNumber(source?.stateId),

//     stateCode: asString(source?.stateCode),

//     stateName: asString(source?.stateName),

//     sourceOrganization: asString(source?.sourceOrganization),

//     sourceSystem: asString(source?.sourceSystem),

//     coverageStartDate: asNullableString(source?.coverageStartDate),

//     coverageEndDate: asNullableString(source?.coverageEndDate),

//     historicalCutoffDate: asNullableString(source?.historicalCutoffDate),

//     observedCoverageStartDate: asNullableString(
//       source?.observedCoverageStartDate
//     ),

//     observedCoverageEndDate: asNullableString(source?.observedCoverageEndDate),

//     historicalCoverageStatus: asString(source?.historicalCoverageStatus),

//     historicalCoverageLabel: asString(source?.historicalCoverageLabel),

//     stamp: asString(source?.stamp),

//     workbookAvailable: asBoolean(source?.workbookAvailable),

//     workbookStatus: asString(source?.workbookStatus, 'NOT_UPLOADED'),

//     latestImportId: asNullableNumber(source?.latestImportId),

//     latestImportIx: asNullableString(source?.latestImportIx),

//     latestImportTrackId: asNullableString(source?.latestImportTrackId),

//     sourceCode: asNullableString(source?.sourceCode),

//     filename: asNullableString(source?.filename),

//     workbookVersion: asNullableString(source?.workbookVersion),

//     checksum: asNullableString(source?.checksum),

//     cohortMethod: asString(source?.cohortMethod),

//     uploaderId: asNullableNumber(source?.uploaderId),

//     uploaderIx: asNullableString(source?.uploaderIx),

//     uploaderCode: asNullableString(source?.uploaderCode),

//     uploaderName: asNullableString(source?.uploaderName),

//     uploaderEmail: asNullableString(source?.uploaderEmail),

//     uploadedAt: asNullableString(source?.uploadedAt),

//     workbookCreatedAt: asNullableString(source?.workbookCreatedAt),

//     summary: {
//       importCount: asNumber(summary?.importCount),

//       worksheetCount: asNumber(summary?.worksheetCount),

//       totalRows: asNumber(summary?.totalRows),

//       stagedRows: asNumber(summary?.stagedRows),

//       pendingRows: asNumber(summary?.pendingRows),

//       validRows: asNumber(summary?.validRows),

//       warningRows: asNumber(summary?.warningRows),

//       failedRows: asNumber(summary?.failedRows),

//       rejectedRows: asNumber(summary?.rejectedRows),

//       committedRows: asNumber(summary?.committedRows),
//     },

//     imports: asArray(source?.imports).map(normalizeImport),

//     warnings: asStringArray(source?.warnings),

//     errors: asStringArray(source?.errors),

//     validationStatus: asString(source?.validationStatus),

//     validationReady: asBoolean(source?.validationReady),

//     blockingIssueCount: asNumber(source?.blockingIssueCount),

//     unresolvedReferenceCount: asNumber(source?.unresolvedReferenceCount),

//     actions: {
//       uploadRequired: asBoolean(actions?.uploadRequired),

//       replaceAllowed: asBoolean(actions?.replaceAllowed),

//       openWorkbench: asBoolean(actions?.openWorkbench),

//       validate: asBoolean(actions?.validate),

//       publishReady: asBoolean(actions?.publishReady),
//     },

//     raw: source,
//   };
// }

// export function normalizeBieHistoricalWorkbookOperation(
//   source: any
// ): BieHistoricalWorkbookOperationResult {
//   return {
//     rid: asNullableNumber(source?.rid),

//     stamp: asNullableString(source?.stp ?? source?.stamp),

//     planningcycleid: asNullableNumber(
//       source?.planningcycleid ?? source?.lsi ?? source?.rid
//     ),

//     raw: source,
//   };
// }
